import { type GeoJSONLineStringFeature } from "./map";

export const MAP_INITIAL_CENTER: [number, number] = [
  21.024997229968335, 52.08543207258063,
];
export const MAP_INITIAL_ZOOM = 15;
export const MAPBOX_CUSTOM_STYLE_URL =
  "mapbox://styles/lasercamp/cmcg7bzqs007u01s9h6q276wn";

export const EXAMPLE_ROUTE_GEOJSON: GeoJSONLineStringFeature = {
  type: "Feature",
  properties: {
    // Add a URL for this route here
    url: "https://maps.app.goo.gl/uYvnZR386hqPEQ7TA",
  },
  geometry: {
    type: "LineString",
    coordinates: [
      [21.02430472582583, 52.179936201229594],
      [21.024312891647952, 52.17995998517878],
      [21.02449458116905, 52.17990866190385],
      [21.02460686121111, 52.179843568884564],
      [21.02475792890303, 52.179717137940884],
      [21.024837545659437, 52.17964203027918],
      [21.024535817773682, 52.179005210219145],
      [21.0226281122346, 52.179377909819266],
      [21.02242057828343, 52.17944597801926],
      [21.022227523444343, 52.179528843513],
      [21.021971725784624, 52.179685695632514],
      [21.02175936546118, 52.17974784443197],
      [21.021575963365137, 52.17977152014262],
      [21.021450477720578, 52.179753763360935],
      [21.021334644817472, 52.179709371375736],
      [21.021252596510863, 52.17964722252205],
      [21.021204332800693, 52.17957619515431],
      [21.02132016570377, 52.179007972129085],
      [21.021506170763132, 52.17800470793861],
      [21.021524098359293, 52.17770128941552],
      [21.021453911877984, 52.17745594850123],
      [21.020572787733954, 52.17503660713311],
      [21.01992639109767, 52.17329747128076],
      [21.019158661090188, 52.17128372285859],
      [21.01876362818433, 52.170141546480664],
      [21.018710980684716, 52.16989937307784],
      [21.017789649415647, 52.167402219341824],
      [21.017363499507297, 52.16610487529772],
      [21.017262477038514, 52.16566226884905],
      [21.0172480452581, 52.16185567165172],
      [21.017420864108715, 52.155489579296045],
      [21.017457236070044, 52.1524434841898],
      [21.017511794012762, 52.1483928590726],
      [21.017573183888544, 52.14547558834656],
      [21.017658334542347, 52.142026727765085],
      [21.01764130441134, 52.141169696735375],
      [21.01745397297441, 52.13989233131667],
      [21.01745556573087, 52.13935574191498],
      [21.018879535644885, 52.092337331601044],
      [21.01897803427582, 52.08838253829083],
      [21.01903369938418, 52.088054186766186],
      [21.019178428667004, 52.087746355017515],
      [21.01972805689593, 52.0868071031108],
      [21.020914472693136, 52.08502956196921],
      [21.021692516886134, 52.083802647240105],
      [21.022560446938485, 52.0824337342504],
      [21.02286644628444, 52.08200310937707],
      [21.023071465845675, 52.08178309419176],
      [21.02344784504021, 52.08140699734656],
      [21.023655924595715, 52.08123775273208],
      [21.023903784064913, 52.08130357015824],
      [21.023668164568818, 52.08149914136686],
      [21.023310145334648, 52.08187711790811],
      [21.02314796568146, 52.082076447530994],
      [21.02293682613302, 52.082354755327344],
      [21.022764798547172, 52.08260213915909],
      [21.022297720614063, 52.08332235214286],
      [21.021900953965172, 52.083954779809034],
      [21.021516975788245, 52.08452353809275],
      [21.02174722241608, 52.08458737996813],
      [21.021810783339333, 52.08464247964733],
      [21.02190385469021, 52.08469827672141],
      [21.02218079871116, 52.084791039202656],
      [21.02231359563868, 52.084827307188135],
      [21.02244525755043, 52.08491239734582],
      [21.02247817302836, 52.08496331187064],
      [21.02251741135126, 52.08500038704315],
      [21.0225790582748, 52.085032390389586],
      [21.023202967655152, 52.085217878723824],
      [21.023513148169883, 52.08531359610498],
      [21.024099041658474, 52.08548099248381],
      [21.024682261925307, 52.08559528869259],
      [21.025656761482765, 52.08589618221086],
    ],
  },
  bbox: [21.01986, 52.085302, 21.02876, 52.083402], // Example bounding box. REPLACE WITH REAL DATA.
};

export const TARGET_LINE_GEOJSON: GeoJSONLineStringFeature = {
  type: "Feature",
  properties: {},
  geometry: {
    type: "LineString",
    coordinates: [
      [21.024925850173048, 52.085555376756815],
      [21.024960718890043, 52.085511288058086],
      [21.024900300410906, 52.08549246906557],
      [21.025019694105964, 52.085343293060674],
      [21.025080043808117, 52.08536235016879],
      [21.025096137062235, 52.08534267499246],
      [21.026327366138702, 52.08571529191735],
    ],
  },
};

// Fixed: JourneyRoute interface is defined here to ensure consistency
export interface JourneyRoute {
  color: string;
  title: string;
  subtitle: string;
  time: string;
  geoJSON: GeoJSONLineStringFeature; // This MUST be present for every route
}

export const JOURNEY_ROUTES: JourneyRoute[] = [
  {
    color: "bg-orange-500",
    title: "Autobus 709 / 727",
    subtitle: "z Metra Wilanowska",
    time: "41 min",
    geoJSON: EXAMPLE_ROUTE_GEOJSON,
  },
  {
    color: "bg-pink-500",
    title: "Samochód",
    subtitle: "od trasy S2",
    time: "13 min",
    geoJSON: {
      type: "Feature",
      properties: {
        // Add a URL for this route here
        url: "https://maps.app.goo.gl/aswPDsLLBrvqE4Rh8", // Example URL for Car
      },
      geometry: {
        type: "LineString",
        coordinates: [
          [21.01745556573087, 52.13935574191498],
          [21.018879535644885, 52.092337331601044],
          [21.01897803427582, 52.08838253829083],
          [21.01903369938418, 52.088054186766186],
          [21.019178428667004, 52.087746355017515],
          [21.01972805689593, 52.0868071031108],
          [21.020914472693136, 52.08502956196921],
          [21.021692516886134, 52.083802647240105],
          [21.022560446938485, 52.0824337342504],
          [21.02286644628444, 52.08200310937707],
          [21.023071465845675, 52.08178309419176],
          [21.02344784504021, 52.08140699734656],
          [21.023655924595715, 52.08123775273208],
          [21.023903784064913, 52.08130357015824],
          [21.023668164568818, 52.08149914136686],
          [21.023310145334648, 52.08187711790811],
          [21.02314796568146, 52.082076447530994],
          [21.02293682613302, 52.082354755327344],
          [21.022764798547172, 52.08260213915909],
          [21.022297720614063, 52.08332235214286],
          [21.021900953965172, 52.083954779809034],
          [21.021516975788245, 52.08452353809275],
          [21.02174722241608, 52.08458737996813],
          [21.021810783339333, 52.08464247964733],
          [21.02190385469021, 52.08469827672141],
          [21.02218079871116, 52.084791039202656],
          [21.02231359563868, 52.084827307188135],
          [21.02244525755043, 52.08491239734582],
          [21.02247817302836, 52.08496331187064],
          [21.02251741135126, 52.08500038704315],
          [21.0225790582748, 52.085032390389586],
          [21.023202967655152, 52.085217878723824],
          [21.023513148169883, 52.08531359610498],
          [21.024099041658474, 52.08548099248381],
          [21.024682261925307, 52.08559528869259],
          [21.025656761482765, 52.08589618221086],
        ],
      },
      bbox: [21.01541, 52.082452, 21.03321, 52.086252],
    },
  },
  {
    color: "bg-blue-500",
    title: "Pieszo",
    subtitle: "z Designer Outlet Warszawa",
    time: "15 min",
    geoJSON: {
      type: "Feature",
      properties: {
        // Add a URL for this route here
        url: "https://maps.app.goo.gl/BWFATiF3gQ5z7pTq6",
      },
      geometry: {
        type: "LineString",
        coordinates: [
          [21.023089821384843, 52.08692356003431],
          [21.022182015316076, 52.087158003531954],
          [21.0225043522544, 52.08761745532027],
          [21.022401533247574, 52.087776825158755],
          [21.02242223390823, 52.08778360894192],
          [21.02233667117676, 52.08791589250379],
          [21.022339431264726, 52.087931155966174],
          [21.022388806667607, 52.0879478986856],
          [21.022516747564936, 52.087982837976114],
          [21.02304143447813, 52.08811862450378],
          [21.023407164518858, 52.08820994269618],
          [21.023297001842906, 52.088335863628004],
          [21.023197011380688, 52.088428021616636],
          [21.023110481172324, 52.08848827865995],
          [21.02300664493248, 52.08852490546346],
          [21.022797049539747, 52.08858161785412],
          [21.022581685465553, 52.088604066488784],
          [21.02234324667043, 52.088609974022404],
          [21.022147111532774, 52.08860052196846],
          [21.02200289451841, 52.088576891824175],
          [21.02069363698166, 52.08825727585344],
          [21.020645410006665, 52.088235874298164],
          [21.020632013624606, 52.08817331584626],
          [21.02045518138297, 52.08808770940243],
          [21.020425709343385, 52.08812228125518],
          [21.020366765262565, 52.088142036587726],
          [21.020267632036308, 52.0881486216968],
          [21.019777324456697, 52.08802350446123],
          [21.019600492175755, 52.08790497203631],
          [21.019584514953294, 52.08788298490305],
          [21.019632164926975, 52.08776697510697],
          [21.019619578142112, 52.08774377311133],
          [21.021669922165728, 52.0845652448582],
          [21.021759331589067, 52.084585486602634],
          [21.021839329494583, 52.084663561815375],
          [21.021909915880826, 52.084704045204944],
          [21.022305199648173, 52.08482549515418],
          [21.02244637242225, 52.084915136571226],
          [21.02250284153189, 52.0849874279059],
          [21.02257950472324, 52.0850309955448],
          [21.02405108344081, 52.085468358804604],
          [21.024682942088674, 52.08559599363599],
          [21.025647084208714, 52.085891996881685],
          [21.025717490461375, 52.0857973585359],
        ],
      },
      bbox: [21.024997229968335, 52.08318632258063, 21.03, 52.08775425], // REPLACE WITH REAL DATA
    },
  },
];